import React from 'react';
import Appearance from '../GroupAppearance/GroupAppearance';
import Conditions from '../ConditionGroup/PropertyConditions';

export default ({ activeTab, scaleText }) => {
  return (
    <>
      {activeTab === 1 && <Appearance scaleText={scaleText} />}
      {activeTab === 3 && <Conditions />}
    </>
  );
};
